import { useEffect } from "react";

/**
 * 지문읽기 설정. ECHO 민트 토글 두 개.
 *
 * - 강의 영상 보여주기: 켜진다(2026-09-28 사장님 결정). 지인에듀가 지문에 강의를 붙여 준
 *   경우에만 학생 지문읽기에 강의가 뜬다. **강의가 뜨면 해석도 함께 보여 준다.**
 *   해석 숨기기를 켜 두었어도 강의가 뜨는 지문은 해석이 보인다(학생 ReadingPage.jsx).
 * - 해석 숨기기: 출제 창을 열면 켜진다(예전부터의 기본).
 */
const ToggleRow = ({ title, description, isOn, onToggle, readOnly }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "11px 14px",
      backgroundColor: "#F4F8F7",
      borderRadius: "12px",
    }}
  >
    <div style={{ flex: 1, minWidth: 0 }}>
      <div
        style={{
          fontSize: "0.86rem",
          fontWeight: 800,
          color: "#0E141B",
          letterSpacing: "-0.01em",
        }}
      >
        {title}
      </div>
      <div style={{ fontSize: "0.74rem", color: "#7A8490", marginTop: "1px" }}>
        {description}
      </div>
    </div>
    <div
      onClick={() => !readOnly && onToggle(!isOn)}
      style={{
        width: "46px",
        height: "27px",
        borderRadius: "999px",
        backgroundColor: isOn ? "#00D9C0" : "#D6DEE0",
        position: "relative",
        cursor: readOnly ? "default" : "pointer",
        transition: "background-color .15s",
        flexShrink: 0,
      }}
    >
      <span
        style={{
          position: "absolute",
          top: "3px",
          left: isOn ? "22px" : "3px",
          width: "21px",
          height: "21px",
          borderRadius: "50%",
          backgroundColor: "#FFF",
          boxShadow: "0 1px 3px rgba(14,20,27,.18)",
          transition: "left .15s",
        }}
      />
    </div>
  </div>
);

const ReadingSelection = ({ selectedTypes, setSelectedTypes }) => {
  const reading = selectedTypes.find((item) => item.key === "reading") || {};
  const hideTranslation = reading.hide_translation;
  // 이 칸이 생기기 전의 설정에는 값이 없다. 없으면 켠 것으로 본다(서버와 같다).
  const showLecture = reading.show_lecture !== false;

  const readOnly = setSelectedTypes === undefined;

  const setReadingOption = (patch) => {
    setSelectedTypes((prev) =>
      prev.map((item) => (item.key === "reading" ? { ...item, ...patch } : item))
    );
  };

  useEffect(() => {
    if (readOnly) return;
    setReadingOption({ hide_translation: true, show_lecture: true });
    // eslint-disable-next-line
  }, []);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <ToggleRow
        title="강의 영상 보여주기"
        description={
          showLecture
            ? "강의가 있는 지문은 학생 지문읽기에 강의부터 뜹니다 (해석도 함께 보여요)"
            : "강의가 있어도 학생에게 띄우지 않습니다"
        }
        isOn={showLecture}
        onToggle={(value) => setReadingOption({ show_lecture: value })}
        readOnly={readOnly}
      />
      <ToggleRow
        title="해석 숨기기"
        description={
          hideTranslation
            ? "학생에게 한글 해석이 보이지 않습니다 (강의가 뜨는 지문은 예외)"
            : "학생이 한글 해석을 함께 볼 수 있습니다"
        }
        isOn={hideTranslation}
        onToggle={(value) => setReadingOption({ hide_translation: value })}
        readOnly={readOnly}
      />
    </div>
  );
};

export default ReadingSelection;
